var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (slides, undefined) {
buf.push("<div id=\"pagination\">");
// iterate slides
;(function(){
  var $$obj = slides;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var slide = $$obj[i];

buf.push("<a" + (jade.attr("href", "#slide/" + (i+1) + "", true, false)) + " class=\"page\"></a>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var slide = $$obj[i];

buf.push("<a" + (jade.attr("href", "#slide/" + (i+1) + "", true, false)) + " class=\"page\"></a>");
    }

  }
}).call(this);

buf.push("</div>");}.call(this,"slides" in locals_for_with?locals_for_with.slides:typeof slides!=="undefined"?slides:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}